import { render, staticRenderFns } from "./channelApiFilterRule.vue?vue&type=template&id=672fc0fd"
import script from "./channelApiFilterRule.vue?vue&type=script&lang=js"
export * from "./channelApiFilterRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports